import {SC_User} from "./SC_User";

export class SC_WorkorderReminder {
    static inputKeys = {
        parentID: 'parentID',
        internalID: 'internalID',
        payload: 'payload',
        created: 'created',
        fireTime: 'fireTime',
        authorID: 'authorID',
        dismissed: 'dismissed',
    };

    internalID: number | null;
    payload: string | null;
    created: Date | null;
    fireTime: Date | null;
    authorID: number | null;
    author: SC_User | null;
    dismissed: boolean | null;

    constructor({
        internalID = null,
        payload = null,
        created = null,
        fireTime = null,
        authorID = null,
        dismissed = null,
    } = {}) {
        this.internalID = internalID;
        this.payload = payload;
        this.created = created;
        this.fireTime = fireTime;
        this.authorID = authorID;
        this.author = null;
        this.dismissed = dismissed;
    }

    static fromAPI(
        jsonin: Record<string, unknown>,
        userr?: SC_User[],
    ): SC_WorkorderReminder {
        const out = new SC_WorkorderReminder({
            internalID: jsonin[this.inputKeys.internalID] ?? null,
            payload: jsonin[this.inputKeys.payload] ?? null,
            // @ts-ignore
            created: jsonin[this.inputKeys.created] ? new Date(jsonin[this.inputKeys.created]) : null,
            // @ts-ignore
            fireTime: jsonin[this.inputKeys.fireTime] ? new Date(jsonin[this.inputKeys.fireTime]) : null,
            authorID: jsonin[this.inputKeys.authorID] ?? null,
            dismissed: jsonin[this.inputKeys.dismissed] ?? null,
        });

        if (userr) {
            out.scavengeUser(userr);
        }

        return out;
    }

    toAPI(): Record<string, unknown> {
        return {
            [SC_WorkorderReminder.inputKeys.internalID]: this.internalID,
            [SC_WorkorderReminder.inputKeys.payload]: this.payload,
            [SC_WorkorderReminder.inputKeys.created]: this.created,
            [SC_WorkorderReminder.inputKeys.fireTime]: this.fireTime,
            [SC_WorkorderReminder.inputKeys.authorID]: this.authorID,
            [SC_WorkorderReminder.inputKeys.dismissed]: this.dismissed,
        };
    }

    /**
     * @returns {SC_WorkorderReminder}
     */
    clone(): SC_WorkorderReminder {
        const cloned = new SC_WorkorderReminder();

        cloned.internalID = this.internalID;
        cloned.payload = this.payload;
        cloned.created = this.created;
        cloned.fireTime = this.fireTime;
        cloned.authorID = this.authorID;
        cloned.dismissed = this.dismissed;

        return cloned;
    }

    /**
     * Merges another SC_WorkorderReminder object into this one, replacing null fields
     * @param {SC_WorkorderReminder} other
     * @returns {SC_WorkorderReminder}
     */
    merge(other: SC_WorkorderReminder): SC_WorkorderReminder {
        if (other.internalID !== null) this.internalID = other.internalID;
        if (other.payload !== null) this.payload = other.payload;
        if (other.created !== null) this.created = other.created;
        if (other.fireTime !== null) this.fireTime = other.fireTime;
        if (other.authorID !== null) this.authorID = other.authorID;
        if (other.dismissed !== null) this.dismissed = other.dismissed;

        return this;
    }

    isDegenerate(): string | undefined {
        if (!this.payload) {
            return 'Reminder content is required';
        }
        if (!this.fireTime) {
            return 'Fire time is required';
        }
    }

    scavengeUser(usarr: SC_User[]): void {
        if (usarr) {
            const user = usarr.find((user) => user.insiteID === this.authorID);
            if (user) {
                this.author = user;
            }
        }
    }

    get overdue(): boolean {
        return !this.dismissed && this.fireTime < new Date();
    }
}
